import React from "react"
import { Box } from "@mui/material"
import { AppAntSwitch } from "@components"
import { AppTiersAutocomplete } from "@components/Autocomplete"
import { BACKEND_APIS } from "@constants"
import useAutoEuropeDataInfo from "Pages/AutoEuropeTool/Page/@hooks/useDataInfo"
import { autoEuropeDrawerData, autoEuropeOriginalData } from "Pages/AutoEuropeTool/Page/@signals"
import { enrichFilterIds } from "Pages/AutoEuropeTool/Page/@utils/filterEnrich"

export default function AutoEuropeExcludeProviders() {
	const d = autoEuropeDrawerData.peek()
	const { dataInfo: idsInfo, setDataInfo: setIds } = useAutoEuropeDataInfo(d.filterGroupProviders ?? [])
	const { dataInfo: exclInfo, setDataInfo: setExcl } = useAutoEuropeDataInfo(d.filterGroupProvidersExclusion ?? false)

	const isExclusion = exclInfo.value
	const ids = idsInfo.value ?? []

	const updateMode = (checked) => setExcl(checked, 'filterGroupProvidersExclusion')
	const updateIds = (_, opts) => setIds(opts ?? [], 'filterGroupProviders')

	return (
		<Box>
			<AppAntSwitch
				falseText="Include providers"
				trueText="Exclude providers"
				falseIcon="circle-check"
				trueIcon="ban"
				checked={isExclusion}
				onChange={e => updateMode(e.target.checked)}
				chipSx={{ mb: 1.5 }}
			/>
			<AppTiersAutocomplete
				multiple
				urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/tiersV2`}
				label={isExclusion ? 'Exclude Tiers' : 'Include Tiers'}
				placeholder={isExclusion ? 'No tiers excluded' : 'No tiers included'}
				value={ids.map(o => o?.value ?? o)}
				onChange={updateIds}
				onAjax={options => { enrichFilterIds('filterGroupProviders', options, autoEuropeDrawerData, autoEuropeOriginalData); return options }}
			/>
		</Box>
	)
}